import React from 'react';

import axios from 'axios';
// eslint-disable-next-line import/named
import { hashHistory, RouteComponentProps } from 'react-router';

import * as Api from '../../Api';
import { storage as storageService } from '../../services/storageServices';
import { Utilities } from '../../Utilities';
import LoadingPanel from '../LoadingPanel';
import { DispatchProps, StateProps } from './index';
import { setCookieUtils } from './setCookieUtils';

type loadStatus = 'NOT_LOADED' | 'LOADING' | 'LOADED';

interface State {
  FoundRestaurant: boolean;
  FoundRestaurantRedirect: boolean;
  loadRestaurantListStatus: loadStatus;
  OpenPWA: boolean;
  Redirect: boolean;
  vrid: number;
}

type Props = StateProps & DispatchProps & RouteComponentProps<{}, {}>;

/**
 * safari w default settings disallows 3rd party cookies to be stored
 * if user haven’t been on that domain in last X days
 * (web-order is 3rd party coz its coming from diff domain)
 * so with help of bounce u visited our domain
 */
export class SetCookie extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);

    this.state = {
      FoundRestaurant: false,
      FoundRestaurantRedirect: false,
      loadRestaurantListStatus: 'NOT_LOADED',
      OpenPWA: false,
      Redirect: false,
      vrid: 0,
    };
  }

  public UNSAFE_componentWillMount(): void {
    const routerState = {
      params: this.props.params,
      pathname: this.props.location.pathname,
    };

    this.props.updateRouterState(routerState);
  }

  public componentDidMount(): void {
    const { hasDeviceId, hasSafariUserAgent } = setCookieUtils;

    Utilities.detectPrivateMode((is_private: any) => {
      const isPrivate =
        typeof is_private === 'undefined'
          ? 'cannot detect'
          : is_private
          ? 'private'
          : 'not private';

      if (isPrivate === 'private') {
        alert(this.props.translate('Private_browsing'));
      }
    });

    const { bounced } = this.props;

    const isThirdPartyCookieWorkAroundRequired =
      !hasDeviceId() || hasSafariUserAgent();

    if (!isThirdPartyCookieWorkAroundRequired) {
      this.props.setBounced(true);
    } else if (!bounced) {
      // https://gist.github.com/iansltx/18caf551baaa60b79206
      const encodedUrl = encodeURIComponent(window.location.href);
      const target = `${axios.defaults.baseURL}/api/weborder/bounce?url=${encodedUrl}`;
      window.location.replace(target);
    }
  }

  public UNSAFE_componentWillReceiveProps(newProps: Props): void {
    const {
      appConfig,
      bounced,
      collectionSummaries,
      findInitialRestaurant,
      flagTargetedLoadingEnabled,
      isClientAnalyticsLoaded,
      location,
    } = newProps;

    if (this.props.location.pathname !== newProps.location.pathname) {
      this.props.updateRouterState({
        pathname: newProps.location.pathname,
        params: newProps.params,
      });
    }

    const isPwa: boolean = Utilities.extraOption('data-pwa') == 'true';

    //Analytics PWA open
    if (
      !this.state.OpenPWA &&
      isClientAnalyticsLoaded &&
      isPwa &&
      Utilities.isStandalone
    ) {
      this.setState({ OpenPWA: true });
    }

    //Redirect on '/'
    if (
      this.props.location.pathname !== location.pathname &&
      location.pathname === '/'
    ) {
      hashHistory.replace('/where');
    }

    if (
      newProps.customer.status === 'success' &&
      this.props.customer.status !== 'success'
    ) {
      this.props.addToast(this.props.translate('Logged_in') as string);
    }

    if (
      bounced &&
      appConfig.status === 'success' &&
      !this.state.Redirect &&
      !Utilities.isStandalone
    ) {
      switch (
        parseInt(Utilities.extraOption('data-webtoappredirect')) ||
        appConfig.data.WebToAppRedirect
      ) {
        case Api.WebToAppRedirect.RedirectOnce:
          if (storageService.getItem<boolean>('flipdish-redirect') === true) {
            this.setState({ Redirect: true });

            const redirectConfirm = window.confirm(
              this.props.translate('Redirect_confirm') as string,
            );

            if (redirectConfirm) {
              if (Utilities.isAndroid && appConfig.data.PlayStoreUrl) {
                window.location.assign(appConfig.data.PlayStoreUrl);
                break;
              } else if (Utilities.isIOSPhone && appConfig.data.AppStoreUrl) {
                window.location.assign(appConfig.data.AppStoreUrl);
                break;
              }
            }
          } else {
            if (Utilities.isAndroid && appConfig.data.PlayStoreUrl) {
              this.setState({ Redirect: true });
              Utilities.setInLocalStorage('flipdish-redirect', true);
              window.location.assign(appConfig.data.PlayStoreUrl);
              break;
            } else if (
              Utilities.isIOSPhone &&
              !(window as any).MSStream &&
              appConfig.data.AppStoreUrl
            ) {
              this.setState({ Redirect: true });
              Utilities.setInLocalStorage('flipdish-redirect', true);
              window.location.assign(appConfig.data.AppStoreUrl);
              break;
            }
          }
          break;

        case Api.WebToAppRedirect.RedirectAlways:
          if (Utilities.isAndroid && appConfig.data.PlayStoreUrl) {
            this.setState({ Redirect: true });
            window.location.assign(appConfig.data.PlayStoreUrl);
            break;
          } else if (Utilities.isIOSPhone && appConfig.data.AppStoreUrl) {
            this.setState({ Redirect: true });
            window.location.assign(appConfig.data.AppStoreUrl);
            break;
          }
          break;

        case Api.WebToAppRedirect.SuggestPwa:
          break;

        case Api.WebToAppRedirect.ForcePwa:
          break;
      }
    }

    if (
      bounced &&
      appConfig.status === 'success' &&
      flagTargetedLoadingEnabled
    ) {
      this.setState({ FoundRestaurant: true });
    }

    // if already bounced and arrive at the / path redirect
    if (
      bounced &&
      appConfig.status === 'success' &&
      !this.state.FoundRestaurant &&
      (newProps.isClientAnalyticsLoaded ||
        this.props.isClientAnalyticsLoaded) &&
      this.state.loadRestaurantListStatus === 'NOT_LOADED'
    ) {
      if (!appConfig.data.DeliveryEnabled && !appConfig.data.PickupEnabled) {
        hashHistory.replace('/unavailable');
      }

      this.setState({ loadRestaurantListStatus: 'LOADING' });

      findInitialRestaurant((vrid: number) => {
        //Prevent further API calls
        this.setState({ FoundRestaurant: true });
        this.setState({ loadRestaurantListStatus: 'LOADED' });

        //Redirect if only on base path
        if (location.pathname === '/') {
          //If CollectionSummaries loaded do the redirect else store vrid in state and wait for CollectionSummaries to load
          if (collectionSummaries.status == 'success') {
            this.redirectToRestaurant(vrid, newProps);
          } else {
            this.setState({ vrid }, () => {
              //If CollectionSummaries were loaded while the initial restaurant was being found
              this.redirectToRestaurant(vrid);
            });
          }
        }
      });
    }

    // once CollectionSummaries has loaded use stored vrid for the redirect
    if (
      collectionSummaries.status == 'success' &&
      collectionSummaries !== this.props.collectionSummaries &&
      this.state.vrid !== 0 &&
      !this.state.FoundRestaurantRedirect
    ) {
      this.redirectToRestaurant(this.state.vrid, newProps);
    }
  }

  public redirectToRestaurant = (vrid: number, newProps?: Props): void => {
    this.setState({ FoundRestaurantRedirect: true });

    const { appConfig, setRestaurantUrl, showRestaurantList } =
      newProps || this.props;

    const isPwa: boolean = Utilities.extraOption('data-pwa') == 'true';

    if (appConfig.status === 'success') {
      const configData = appConfig.data;
      const isMobilePWA =
        (Utilities.isAndroid || Utilities.isIOSPhone) &&
        Utilities.isStandalone &&
        isPwa;
      const lastUrl = storageService.getItem('flipdish-last-url');
      const lastUrlExpiry = storageService.getItem('flipdish-last-url-expiry');
      const hasActiveUrl =
        lastUrl && lastUrlExpiry && Date.now() < parseInt(lastUrlExpiry);

      if (isMobilePWA && hasActiveUrl) {
        hashHistory.replace(lastUrl.substr(1));
      } else if (
        !configData.PickupEnabled &&
        configData.DisplayDeliveryRestaurantListScreen
      ) {
        hashHistory.replace('/delivery');
      } else if (
        !configData.DeliveryEnabled &&
        configData.DisplayPickupRestaurantListScreen
      ) {
        hashHistory.replace(this.getCollectionLink());
      } else if (!showRestaurantList) {
        const url = `/restaurant/${vrid}`;
        setRestaurantUrl(url);
        hashHistory.replace(url);
      } else {
        hashHistory.replace('/where');
      }
    }
  };

  public getCollectionLink(): string {
    const { appConfig, collectionSummaries } = this.props;

    if (appConfig.status !== 'success') {
      return '/collection';
    }

    if (appConfig.data.DisplayPickupRestaurantListScreen) {
      return '/collection';
    }

    if (collectionSummaries.status !== 'success') {
      return '/collection';
    }

    const [skip] = collectionSummaries.data.filter(
      (c) => c.SkipToThisPhysicalRestaurant,
    );

    if (!skip) {
      return '/collection';
    }

    return `/restaurant/${skip.VirtualRestaurantId}/collection/${skip.PhysicalRestaurantId}`;
  }

  public renderChildren(): null | unknown {
    const { children } = this.props;

    if (!children) {
      return null;
    }

    return React.Children.map(children, (c) => {
      return React.cloneElement(c as any, {
        parentComponent: this,
      });
    });
  }

  public render(): JSX.Element {
    const { appDesignScheme, bounced, isDark } = this.props;

    // const isPwa: boolean = Utilities.extraOption('data-pwa') === 'true';

    // if (!isPwa && Utilities.isStandalone) {
    //   return <LoadingPanel isDark={isDark} AppDesignScheme={appDesignScheme} />;
    // }

    if (!bounced) {
      return <LoadingPanel isDark={isDark} AppDesignScheme={appDesignScheme} />;
    } else {
      return <>{this.renderChildren()}</>;
    }
  }
}
